<template>
  <div class="sale-order-wrap" >
    <!-- 侧边栏 -->
    <transition name="el-fade-in">
      <orderSide ref="orderSide" v-show="isCollapse"  @fetchData="fetchData" ></orderSide>
    </transition>
    <!-- 列表内容 -->
    <orderMain ref="orderMain" @fetchData="fetchData" ></orderMain>
  </div>
</template>
<script>
import orderSide from '@/pages/orderBox/saleOrder/components/orderSide.vue'
import orderMain from '@/pages/orderBox/saleOrder/components/orderMain.vue'
  export default {
    name:'saleOrder',
    components: {
        orderSide,orderMain
    },

    data () {
      return {
        isCollapse: true,
        flagTags:[],
        textTags:[],
      }
    },
    computed: {
      
    },
    
    mounted() {
      this.fetchData()
      this.getTagList()
      this.getWarehouse()
    },
    methods: {
      fetchData(type){
        if (type == 'search' || type == 'reset' ) {
         this.$refs.orderMain.page.pageNo = 1
        }
        let data = {
          pageNo:this.$refs.orderMain.page.pageNo,
          pageSize:this.$refs.orderMain.page.pageSize
        }
        console.log('>>',data)
        if(type != 'reset'){
          data = {
            ...data,
            ... this.$refs.orderSide.form
          }
        }
        this.$refs.orderMain.loading = true
        console.log('>>',data)
        this.$api.omsOrderList(data).then((res) => {
            if (res.code == 0 && res.data.list) {
              this.$refs.orderMain.list = res.data.list
              this.$refs.orderMain.page.totalNum = res.data.totalNum
            }else {
              this.$refs.orderMain.list = []
              this.$refs.orderMain.page.totalNum = 0
            }
        }).finally(() => {
          this.$refs.orderMain.loading = false
        })
        // 统计数据
        this.$api.omsOrderStatistics(data).then((res) => { 
          if (res.code == 0) {
            this.$refs.orderMain.orderStatistics = res.data
          }else {
            this.$refs.orderMain.orderStatistics = {}
          }
        })
        // 角标统计
        this.$api.omsStatisticsBadge(data).then((res) => { 
          if (res.code == 0 && res.data) {
             let orderStatistics = {}
             let exceptionStatistics = {}
             let orderTotal = 0
             let exceptionTotal = 0             
            if(res.data.orderStatusStatistics && res.data.orderStatusStatistics.length>0){ 
              for (let item of res.data.orderStatusStatistics) {
                orderStatistics[item.statusId] = item.orderCount;
                orderTotal += Number(item.orderCount)
              }
              orderStatistics.total = orderTotal
            }
            if(res.data.orderExceptionStatistics && res.data.orderExceptionStatistics.length>0){ 
              for (let item of res.data.orderExceptionStatistics) {
                exceptionStatistics[item.exceptionId] = item.orderCount;
                exceptionTotal += Number(item.orderCount)
              }
              exceptionStatistics.total = exceptionTotal
            }
            this.$refs.orderSide.orderStatistics = orderStatistics
            this.$refs.orderSide.exceptionStatistics = exceptionStatistics
            console.log('orderStatistics:',orderStatistics,exceptionStatistics)
          }
        })
      },
      // 发货仓库
      getWarehouse() { 
        this.$api.omsWarehouse().then(res => {
          if (res.code === 0) {
            this.$refs.orderSide.warehouseList = res.data
          }
        })
      },
      // 获取订单标签列表
      getTagList(){
        this.$api.omsOrderTag().then(res => {
          if (res.code === 0) {
            this.flagTags = res.data.flagTags
            this.textTags = res.data.textTags
            this.$refs.orderMain.flagTags =  this.flagTags
            this.$refs.orderMain.textTags =  this.textTags
          }
        })
      }
    },
  }
</script>
<style lang='scss'>
// 下拉菜单样式
.el-select-dropdown{
  min-width: 90px!important;
  // margin-left: 8px;
  margin-top: 5px!important;
   .el-select-dropdown__item{
    font-size: 12px;
    padding: 0 10px;
    line-height: 28px;
    height: 28px;
  }
}
</style>
<style lang='scss' scoped>
// 全局样式调整
.sale-order-wrap{
  /deep/{
    .el-button--mini{
      padding: 5px;
      font-family: PingFang SC;
      font-weight: 400;
      border-radius: 2px;
    }
    .el-button--primary.is-plain{
      background-color: #fff;
      &:active,
      &:focus,
      &:hover{
        color: #409EFF;
        background-color: #ecf5ff;
      }
    }
    .el-input--mini{
       .el-input__inner{
        height: 24px;
        line-height: 24px;
    }

    }
    .el-input-group__append{
      border-top-right-radius: 2px;
    }
    .el-input-group__prepend{
      border-top-left-radius: 2px;
      border-bottom-left-radius: 2px;
      .el-select{
        margin-left: -11px;
      }
    }
    .el-input__icon{
         font-size: 11px;
        line-height: 24px;
      }
    .el-input__inner{
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
    }
    .select-mini{
      width: 100%;
      max-width: 180px;
      .el-input__suffix{
        right: 0;
      }
    }
    .el-select-dropdown__item{
      font-size: 12px;
    }
    .data-picker{
      width: 100%;
      max-width: 180px;
      height: 24px;
      line-height: 24px;
      padding: 0 4px 0 6px!important;

      .el-range__icon{
        display: none;
      }
      .el-icon-cricle-close{
        width: 67px;
      }
      .el-range-separator{
        width: 24px;
        padding: 0;
        font-size: 11px;
        line-height: 22px;
        text-align: center;
      }
      .el-range__close-icon{
        margin-top: -3px;
        width: 16px;
      }
    }
    .group-con{
      .el-input--mini{
        .el-input__suffix{
          right: 0;
        }
      }
    }
    
  }
  // 侧边栏和主栏
  display: flex;
  .side-wrap{
    margin-right: 10px;
  }
  .main-wrap{
  
  }

}
</style>